/**
 * Konfig pre debugovatelne veci pre trat
 */
export const hillLineDebugConfig = {

  /** Moznost vytvorenia ciar */
  createDebugLines: false,

  /** Debug ciary */
  showDebugLine: false,

  /** Debug sfery */
  showDebugSpheres: false,

  /** Pomocne ciary pre rotaciu */
  arrowHelpers: false,

  /** Vytvorenie ciar pod hracom */
  createLinesUnderPlayer: false,

  /** Zobrazenie debug pre naskocenie */
  showDebugJumpIn: false,

  /** Zobrazenie debug pre naskocenie - iba ideal */
  showDebugJumpInIdeal: false,

  /** Zobrazenie idealnej cesty v zakrutach */
  showIdealPathInTurn: {
    showLine: false,
    showArrows: true
  },

  /** ci zobrazime body na ktore ukladame idealne body */
  showIdealPathPoints: false,

  /** Zobrazenie ciar medzi triggerovymi bodmi sektorov */
  debugLinesTriggersSectors: false,

  /** Zobrazenie ciar medzi triggerovymi bodmi */
  debugLinesTriggers: false

}
